import { EventEmitter } from "@angular/core";

export class FileUploaderModel {
    fileUploaderSettings : any = {};
    uploadedFiles: any[] = [];
    errorMessage: any[] = [];

    constructor() {
    }

    public set Parameter(val: any) {
        try {
          if (val) {
            this.fileUploaderSettings = (!!val[0] && !!val[0].fileUploaderSettings) ? val[0].fileUploaderSettings : {};
            this.uploadedFiles = (!!val[0] && !!val[0].uploadedFiles) ? val[0].uploadedFiles : [];
            this.errorMessage = (!!val[0] && !!val[0].errorMessage) ? val[0].errorMessage : null;
          }
        }
        catch (e) {
            console.error(e);
        }
    }
}
